import { AbstractControl, ValidationErrors } from "@angular/forms";

export function requiredLengthValidator(n: number): (control: AbstractControl) => null | ValidationErrors {
    return (control: AbstractControl) => {
        if (!control) return null;
        if (!control.value) return null;
        let numbers = control.value.toString();
        if (numbers.length === n) return null;

        return {
            'numbers': {
                actual: numbers.length,
                expected: n
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/required-length.validator.ts